<script setup lang="ts">
import { TmlErrorAlertBox } from '@teemill/components';
import type { RouteLocationRaw } from 'vue-router';
import type { NotificationContent } from '../useNotifications';

withDefaults(
  defineProps<{
    message: NotificationContent;
    level?: 'danger' | 'warning' | 'success';
    actions?: ({
      text: string;
      as: 'primary' | 'secondary';
    } & (
      | {
          handler: () => void;
        }
      | {
          to: RouteLocationRaw;
        }
    ))[];
  }>(),
  {
    level: 'warning',
    to: undefined,
    actions: undefined,
  },
);
</script>

<template>
  <TmlErrorAlertBox :error="{ level, message, actions }" center />
</template>
